<template>
  <div class="result" :class="{ fixedHeight: isFixed }">
    <!-- <div class="hd">
        <img v-lazy="img" class="ml-20 fl mr-10">
        <div class="userInfo">
            <p class="f18">
                {{name}}
                <span v-if="isVip" class="vip"></span>
                <span v-if="!isVip" class="vip-no"></span>
            </p>
            <p class="f14 mt-10"> 测评完成时间: &nbsp;{{finishTime}}</p>
        </div>
    </div> -->
    <div class="imgbg">
      <img v-lazy="bgimg" class="head img" />
    </div>
    <div id="test_result">
      <div
        style="
          margin: 0 13px;
          background: linear-gradient(
            rgba(237, 244, 245, 0.77) 0%,
            rgba(214, 230, 232, 0.77) 100%
          );
          border-radius: 24px 24px 0px 0px;
          padding-top: 32px;
        "
      >
        <div class="report_logo"></div>
        <div class="nameTime">
          被测人:{{
            name && name.length > 10 ? name.slice(0, 10) + "..." : name
          }}
          <span>完成时间: {{ finishTime.slice(0, 10) }}</span>
        </div>
        <div class="content">
          <!-- 动态获取背景为圆形或方形（最外面的大圆） -->
          <div
            :class="[isCircle ? 'bg-rectangle' : 'bg-circle', { thfg: isThfg }]"
            v-if="!zyzhx && !isSleepReport"
          >
            <div
              id="myChart"
              :style="{
                top:
                  dimensionless.length != 1 || level == '-' || mychart.length
                    ? '50%'
                    : '40%',
              }"
            >
              <!-- 含渣量测评报告 -->
              <div
                v-if="hideChart"
                style="
                  height: 100%;

                  width: 100%;

                  padding: 9%;
                "
              >
                <span class="img1"></span>
                <span class="img2"></span>
                <span
                  style="
                    position: absolute;

                    top: -3%;

                    left: calc(50% - 6px);

                    font-size: 12px;

                    color: #42686e;
                  "
                  >高</span
                >
                <span
                  style="
                    position: absolute;

                    bottom: -3%;

                    left: calc(50% - 6px);

                    font-size: 12px;

                    color: #42686e;
                  "
                  >低</span
                >
                <span
                  style="
                    position: absolute;

                    left: -3%;

                    top: calc(50% - 6px);

                    font-size: 12px;

                    color: #42686e;
                  "
                  >低</span
                >
                <span
                  style="
                    position: absolute;

                    right: -3%;

                    top: calc(50% - 6px);

                    font-size: 12px;

                    color: #42686e;
                  "
                  >高</span
                >
                <div
                  style="
                    width: calc(100% - 10px);

                    height: calc(100% - 10px);

                    position: relative;
                  "
                >
                  <span
                    :style="`display: block; background: #42686E; width: 10px; height: 10px; position: absolute; left:calc(${numbers}%); 

                                    top: calc(100% - ${number}%); border-radius: 50%;`"
                  >
                  </span>
                  <span
                    :style="`display: block;  width: 100px;  position: absolute; left:calc(${numbers}% - 10px); 

                                    top: calc(${
                                      100 - number
                                    }%  + 10px); border-radius: 5px;font-size: 12px;padding: 3px;color: white;line-height: 17px;`"
                  >
                    <div
                      style="
                        text-align: left;
                        background: #42686e;
                        width: fit-content;
                        padding: 5px;
                        border-radius: 5px;
                      "
                    >
                      <span>{{ levelA }}<br />{{ levelB }}</span>
                    </div>
                  </span>
                  <span
                    style="
                      position: absolute;

                      display: block;

                      left: calc(50% + 11px);

                      font-size: 11px;

                      top: -5%;

                      color: #42686e;

                      z-index: -1;
                    "
                  >
                    {{ name1 }}
                  </span>
                  <span
                    style="
                      position: absolute;

                      top: calc(50% + 11px);

                      right: -12%;

                      font-size: 11px;

                      color: #42686e;

                      z-index: -1;
                    "
                  >
                    {{ name2 }}
                  </span>
                </div>
              </div>
              <!-- 思维风格测评报告 -->
              <div v-if="swfg" style="position: relative">
                <img v-lazy="imgres" style="height: 100%; width: 100%" />
                <div
                  style="position: absolute; top: 29px; left: calc(50% - 24px)"
                  class="resFont"
                >
                  <div>{{ dimensionless[0].level }}</div>
                  <div class="resFont1">{{ dimensionless[0].name }}</div>
                </div>
                <div
                  style="position: absolute; top: 35%; left: 7%"
                  class="resFont"
                >
                  <div>{{ dimensionless[1].level }}</div>
                  <div class="resFont1">{{ dimensionless[1].name }}</div>
                </div>
                <div
                  style="position: absolute; top: 35%; right: 7%"
                  class="resFont"
                >
                  <div>{{ dimensionless[2].level }}</div>
                  <div class="resFont1">{{ dimensionless[2].name }}</div>
                </div>
                <div
                  style="position: absolute; top: 75%; left: 19%"
                  class="resFont"
                >
                  <div>{{ dimensionless[3].level }}</div>
                  <div class="resFont1">{{ dimensionless[3].name }}</div>
                </div>
                <div
                  style="position: absolute; top: 75%; right: 19%"
                  class="resFont"
                >
                  <div>{{ dimensionless[4].level }}</div>
                  <div class="resFont1">{{ dimensionless[4].name }}</div>
                </div>
              </div>
              <!-- 讨好型人格测评报告 -->
              <div v-if="thfg" style="position: relative">
                <div
                  style="
                    position: absolute;
                    top: 48px;
                    left: -18px;
                    right: -19px;
                    overflow: hidden;
                    border-radius: 5%;
                  "
                >
                  <img v-lazy="imgUrl" style="width: 100%; height: 100%" />
                </div>
              </div>
            </div>
            <!-- 讨好型人格测评报告 -->
            <div
              style="
                position: relative;
                bottom: 30px;
                color: #42686e;
                font-weight: 500;
                font-size: 20px;
                font-family: SourceHanSansCN-Regular;
              "
              v-if="
                dimensionless.length == 1 && level != '-' && !mychart.length
              "
            >
              {{ score }}分
              <span v-if="level != '-'">·{{ level }}</span>
            </div>
          </div>
          <div v-else-if="zyzhx" class="bg-rectangle">
            <div
              v-for="(item, index) in mychart"
              :key="index"
              style="height: 55px"
            >
              <div
                :id="'zyChart_' + index"
                style="
                  width: 250px;
                  height: 40px;
                  margin: 0 auto;
                  position: relative;
                "
              ></div>
              <div class="box">
                <div
                  class="left"
                  :style="{
                    color:
                      item.colors[0] == '#f5f5f5' ? '#808080' : item.colors[0],
                  }"
                >
                  <span>{{ item.left }}%<br /></span>
                  {{ item.names[0] }}
                  <!-- <span>{{ item.left }}%</span> -->
                </div>
                <div
                  class="right"
                  :style="{
                    color:
                      item.colors[1] == '#f5f5f5' ? '#808080' : item.colors[1],
                  }"
                >
                  <span>{{ item.right }}%<br /></span>
                  {{ item.names[1] }}
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="orangeBox" v-if="thingWannaSay!=undefined">
                    <div class="title">
                        我想对你说
                    </div>
                    <div class="content">

                        {{thingWannaSay}}
                    </div>
                </div> -->
          <div v-if="thingWannaSay != undefined" class="rect1">
            <div class="left-mark1"></div>
            <div class="title">写在前面</div>
            <div class="result_desc1" v-html="changeQuote(thingWannaSay)"></div>
          </div>
          <div v-for="(dim, index) in displayDimensions" :key="index">
            <div
              v-if="!isOldTest"
              v-show="!(displayDimensions.length == 2 && dim.name == '焦虑')"
            >
              <div
                v-if="
                  dim.description.desc !== undefined &&
                  dim.description.desc != ''
                "
                class="rect"
              >
                <div class="left-mark"></div>
                <div class="title1">{{ dim.level }}</div>
                <div
                  class="result_desc"
                  v-html="changeQuote(dim.description.desc)"
                  style="line-height: 24px"
                >
                  <!-- {{dim.description.desc}} -->
                </div>
              </div>
              <div
                v-show="
                  dim.description.detail &&
                  dim.description.detail.length &&
                  !isThfg
                "
                style="
                  display: flex;
                  align-items: baseline;
                  margin: 20px;
                  margin-top: 70px;
                  margin-bottom: 10px;
                "
              >
                <div
                  style="
                    width: 100%;
                    height: 3px;
                    background-color: #42686e;
                    display: flex;
                    justify-content: flex-end;
                    align-items: flex-end;
                  "
                >
                  <div
                    style="width: 20px; height: 8px; background-color: #42686e"
                  ></div>
                </div>
                <div
                  style="
                    width: 100%;
                    color: #42686e;
                    font-size: 22px;
                    margin: 0 10px;
                  "
                >
                  <span style="white-space: nowrap">{{
                    dim.name == "亲近依赖" ? "测评结果" : dim.name
                  }}</span>
                </div>
                <div
                  style="
                    width: 100%;
                    height: 3px;
                    background-color: #42686e;
                    display: flex;
                    align-items: flex-end;
                  "
                >
                  <div
                    style="width: 20px; height: 8px; background-color: #42686e"
                  ></div>
                </div>
              </div>
              <div v-if="dim.charts" style="width: 100%; height: 5.1rem">
                <div
                  v-if="dim.name == '你的SM倾向'"
                  style="
                    width: calc(100vw - 0.72rem);
                    height: 100%;
                    margin: 0 auto;
                    margin-top: 24px;
                    margin-bottom: 17px;
                  "
                  id="myChart3"
                ></div>
                <div
                  v-else
                  style="
                    border-radius: 15px;
                    width: calc(100vw - 0.72rem);
                    height: 100%;
                    margin: 0 auto;
                    box-shadow: 0rem 0.02rem 0.12rem 0.02rem #42686e;
                    background: #7d9a9e;
                    margin-top: 24px;
                    margin-bottom: 17px;
                  "
                  :id="'myChart2_' + index"
                ></div>
              </div>
              <div style="position: relative; margin-top: 10px">
                <div style="position: relative; z-index: 11; bottom: 0">
                  <result_window
                    v-for="(dets, index) in dim.description.detail"
                    :key="index"
                    :text="dets"
                    :is-sleep-report="isSleepReport"
                    :is-old-test="isOldTest"
                    :resultpage_price="resultpage_price"
                  >
                  </result_window>
                </div>
              </div>
            </div>
            <div v-else>
              <result_window
                :text="
                  changeTextToObject(dim, index == displayDimensions.length - 1)
                "
                :is-sleep-report="isSleepReport"
                :is-old-test="isOldTest"
                :resultpage_price="resultpage_price"
              >
              </result_window>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-10 ftbtnGroup">
      <div
        style="
          display: flex;
          justify-content: space-between;
          width: 100%;
          padding-left: 5%;
          padding-right: 5%;
        "
      >
        <!-- <van-button
          class="ftbtn savebtn ftbtnGroup_savebtn"
          @click="toCode()"
          v-show="isOldTest"
          >保存结果
        </van-button> -->
        <!-- <van-button class="ftbtn savebtn ftbtnGroup_savebtn" @click="toCode()"
          >保存结果
        </van-button> -->
        <van-button
          class="ftbtn rlbtn"
          :class="{
            ftbtnGroup_assess_long: false,
            ftbtnGroup_assess: true,
          }"
          v-if="!isCommented"
          @click="comment()"
          >留下你的评价吧
        </van-button>
        <van-button
          class="ftbtn rlbtn"
          :class="{
            ftbtnGroup_assess_long: false,
            ftbtnGroup_assess: true,
          }"
          v-if="isCommented"
          @click="goMycomment(eval_id)"
          >查看评价
        </van-button>
      </div>
      <!-- 返回首页按钮 -->
      <van-button class="ftbtn ftbtnGroup_tohome" @click="goHome()">
        返回首页
      </van-button>
    </div>
    <div class="assImg">
      <naviateToWxapp></naviateToWxapp>
    </div>
    <div class="ml-10 rel_test">
      <p class="h1 f18 mt-25 mb-10 ml-10 rel_test_title">
        相关推荐
        <span class="fr f14 mr-10 rel_test_more" @click="goClass()"
          >查看更多></span
        >
      </p>
      <!-- 文章推荐列表 -->
      <result_article
        :key="content"
        v-for="content in articleData"
        :content="content"
      ></result_article>
      <!-- 测评推荐列表 -->
      <testList :tests="rTests"></testList>
    </div>
    <div class="mb-20">
      <van-button class="ftbtn allbtn ftbtnGroup_checkall" @click="goClass()"
        >查看全部测评>
      </van-button>
    </div>

    <!-- 這是跳轉到微信的組件 -->
    <!-- <div class="close" v-show="show" @click="show = false">X</div> -->
    <!-- <appointGuilder :isShow="show"></appointGuilder> -->
    <!-- <naviateToWxapp :isShow="show"></naviateToWxapp> -->
    <!-- end -->
    <!-- 点击阅读更多 -->
    <!-- <watchMore
      :resultpage_price="resultpage_price"
      :lock_status="lock_status"
      ref="watchMore"
    ></watchMore> -->
  </div>
</template>

<script>
import naviateToWxapp from "./components/naviateToWxapp";
import appointGuilder from "./components/appoint";
import result_article from "./article";
import result_detail from "./result_detail";
import result_window from "./result_window";
import TestList from "@/components/TestList";
import watchMore from "./components/payWatch";
import { getRelatedTest, getTestRes, getArticles } from "@/http/api";
import { mapGetters } from "vuex";
import sdk from "../../../mixin/share";
import testData from "./data.json";
// import articleData from "./article.json";
import QRCode from "qrcodejs2";
import { Toast } from "vant";
// import vshare from 'vshare';
import Share from "vue-social-share";
import store from "../../../store";
import router from "../../../router";

import { ShareSign } from "@/http/api";

export default {
  name: "result",

  data() {
    return {
      firstShow: true,
      lock_status: "out",
      swfg: false,
      show: false,
      thfg: false,
      isThfg: false,
      isCircle: false,
      zyzhx: false, //职业自画像
      tResTitle: "",
      imgres: require("../../../assets/img/test/imgres.png"),
      bgimg: "",
      name1: "",
      name2: "",
      number: 0,
      numbers: 0,
      hideChart: false,
      thingWannaSay: "",
      level: "",
      levelA: "",
      levelB: "",
      score: "",
      articleData: [],
      testData,
      evaId: "",
      isVip: false,
      isOldTest: false,
      img: "",
      isCommented: "",
      resultImg: "",
      resBgImg: require("../../../assets/img/test/score_bg.png"),
      name: "用户名",
      finishTime: "2020.05.17 10.32.21",
      rTests: [],
      dimensionless: [
        {
          description: "",
        },
      ],
      mychart: [],
      showShare: false,
      testName: "",
      maxScore: 0,
      minScore: "",
      interval_length: "",
      arr: [],
      mount: 0,
      indicator: [],
      appraisal_id: "",
      returnUrl: "",
      imgUrl: "",
      //来储存滑动高度
      currentHeight: 0,
      //显示付费按钮以及固定页面高度
      isFixed: false,
      resultpage_price: -1,
      nameList: [
        [
          { name: "外向", score: 5 },
          { name: "内向", score: 10 },
        ],
        [
          { name: "知觉", score: 3 },
          { name: "判断", score: 12 },
        ],
      ],
    };
  },
  computed: {
    ...mapGetters(["user", "eval_id"]),
    isSleepReport() {
      return this.testName === "睡眠障碍测评结果";
    },
    topDimension() {
      if (!Array.isArray(this.dimensionless) || !this.dimensionless.length) {
        return null;
      }
      return this.dimensionless.reduce((maxItem, currentItem) => {
        const maxScore = Number(maxItem && maxItem.score) || 0;
        const currentScore = Number(currentItem && currentItem.score) || 0;
        return currentScore > maxScore ? currentItem : maxItem;
      }, this.dimensionless[0]);
    },
    displayDimensions() {
      if (this.isSleepReport && this.topDimension) {
        return [this.topDimension];
      }
      return this.dimensionless;
    },
  },
  beforeDestroy() {
    localStorage["first"] = "";
  },
  created() {
    //获取滑动高度并传值
    //console.log(this.$route)
    // setTimeout(()=>{
    //   if(!localStorage["first"]){
    //     this.$router.go(0)
    //        localStorage["first"] = 1
    //   }
    // })
    // setTimeout(()=>{

    // })
    window.addEventListener("scroll", this.handleScroll, true);
    // window.addEventListener("scroll", this.handleScroll());
    if (this.$route.query.type === "share") {
      console.log(123);
      let obj = this.getUrlInfo();
      this.appraisal_id = obj.appraisal_id;
      this.img = decodeURIComponent(obj.img1);
      this.name = obj.Name || this.user.nick_name;
      this.isVip = obj.ISVip;
    } else {
      this.img = this.user.avatar;
      this.name = this.user.nick_name;
      this.isVip = this.user.is_vip.key === "yes";
      this.appraisal_id = store.state.appraisal_id;
    }
    // console.log("成功", this.img, this.name, this.isVip, this.appraisal_id);
    let params = {
      page: 1,
      page_size: 10,
      appraisal_id: this.appraisal_id,
    };
    getRelatedTest(params).then((res) => {
      //console.log(res)
      if (res.data.objects) {
        this.rTests = res.data.objects.map((u) => {
          return {
            evaluation: u,
          };
        });
      }
    });
    const scrollContainer = document.querySelector(".vd-content");
    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
    }
    //对data数据初始化
    this.swfg = false;
    this.thfg = false;
    this.isThfg = false;
    this.isCircle = false;
    this.zyzhx = false;
    getTestRes({
      appraisal_id: this.appraisal_id,
    })
      .then((res) => {
        //背景图片
        this.lock_status = res.data.lock_status.key;
        this.resultpage_price = parseFloat(res.data.resultpage_price);
        localStorage.setItem("resultData", res.data);
        this.bgimg = res.data.evaluation.detail_image;
        //console.log('测评结果',res.data,this.appraisal_id)
        this.thingWannaSay =
          res.data.result.dimensionless[0].description.wanna_say;
        console.log(this.thingWannaSay);
        this.finishTime = res.data.finish_time;
        this.name = res.data.tester.name;
        this.evalId = res.data.evaluation.id;
        store.commit("set_appraisal_id", res.data.evaluation.id);
        store.commit("set_eval_id", res.data.id);
        // console.log(this.evalId)
        this.resultImg = res.data.evaluation.home_image;
        this.dimensionless = res.data.result.dimensionless;
        console.log(this.dimensionless);
        this.isOldTest =
          res.data.result.dimensionless[0].description.detail === undefined;
        // console.log(this.isOldTest)
        this.testName = res.data.result.name;
        console.log("[result-debug] report", {
          resultName: this.testName,
          isSleepReport: this.isSleepReport,
          isOldTest: this.isOldTest,
          dimensionless: (res.data.result.dimensionless || []).map((item) => ({
            name: item.name,
            level: item.level,
            score: item.score,
            hasDesc: !!(item.description && item.description.desc),
            detailLength:
              item.description && item.description.detail
                ? item.description.detail.length
                : 0,
          })),
        });
        let valueArr = [];
        // let
        if (res.data.result.mychart) {
          this.mychart = res.data.result.mychart;
          if (res.data.result.mychart.length == 2) {
            this.levelA =
              res.data.result.mychart[0].name +
              ":" +
              res.data.result.mychart[0].score;
            this.levelB =
              res.data.result.mychart[1].name +
              ":" +
              res.data.result.mychart[1].score;
          }
        } else if (
          res.data.result.dimensionless.length == 1 ||
          res.data.evaluation.title == "独处行为测评"
        ) {
          this.level = res.data.result.dimensionless[0].level;
          this.score = res.data.result.dimensionless[0].score;
        }
        if (res.data.result.dimensionless.length == 2) {
          this.levelA =
            res.data.result.dimensionless[0].name +
            ":" +
            res.data.result.dimensionless[0].level;
          this.levelB =
            res.data.result.dimensionless[1].name +
            ":" +
            res.data.result.dimensionless[1].level;
        }
        this.maxScore = res.data.result.max_score;
        this.minScore = res.data.result.min_score;
        this.intervalLength = res.data.result.interval_length;
        let indicator;
        //这里是处理数据的
        if (res.data.result.mychart) {
          indicator = res.data.result.mychart.map((u) => {
            // if (res.data.result.mychart.length >= 1) {
            valueArr.push(
              ((u.score - u.min_score) * this.intervalLength) /
                (u.max_score - u.min_score)
            );
            // }
            return {
              text: u.name,
              max: this.intervalLength,
            };
          });
        } else {
          indicator = this.dimensionless.map((u) => {
            if (res.data.result.dimensionless.length >= 1) {
              valueArr.push(
                ((u.score - u.min_score) * this.intervalLength) /
                  (u.max_score - u.min_score)
              );
            }
            return {
              text: u.name,
              max: this.intervalLength,
            };
          });
          if (res.data.result.dimensionless.length == 1) {
            indicator = this.dimensionless.map((u) => {
              valueArr.push(u.score - this.minScore);
              return {
                text: u.name,
                max: this.intervalLength,
              };
            });
          }
        }

        this.arr = valueArr;
        console.log(valueArr);
        this.indicator = indicator;
        this.mount = res.data.result.dimensionality_count;
        if (this.dimensionless.length === 1) {
          this.mount = 1;
        }
        if (res.data.evaluation.title == "独处行为测评") {
          this.mount = 1;
        }
        if (res.data.result.mychart) {
          this.mount = res.data.result.mychart.length;
        }
        console.log(this.evalId);
        getArticles(this.evalId).then((res) => {
          this.articleData = res.data.objects;
          console.log(this.articleData);
        });
        res.data.result.dimensionless.forEach((item, index) => {
          let that = this;
          if (item.charts) {
            setTimeout(function () {
              let max = item.charts.yMaxData && item.charts.yMaxData[0];
              if (item.name == "你的SM倾向") {
                that.drawPie(
                  item.charts.xData,
                  item.charts.yData,
                  item.charts.yMaxData
                );
              } else {
                that.drawLines(
                  item.charts.xData,
                  item.charts.yData,
                  index,
                  max
                );
              }
            }, 500);
          }
        });

        if (res.data.result.name == "真爱人格速配指南结果") {
          console.log(11222);
          let chaX = [];
          let chaY = [];
          res.data.result.mychart.forEach((item, index) => {
            // console.log(item)
            chaX.push(item.name);
            chaY.push((item.score / item.max_score) * 10);
            console.log(chaX);
            console.log(chaY);
            if (index == 3) {
              this.drawLineZY(chaX, chaY, 10);
            }
          });
          // console.log(chaX)
          //  console.log(chaY)
        } else if (res.data.result.name == "思维风格测评结果") {
          this.swfg = true;
        } else if (res.data.result.name == "讨好型人格测试结果") {
          this.tResTitle = res.data.result.name;
          this.thfg = true;
          this.isThfg = true;
          this.isCircle = true;
          let levelName = res.data.result.dimensionless[0].level;
          switch (levelName) {
            case "认知型":
              this.imgUrl =
                "https://meditation-1256110421.cos.ap-chengdu.myqcloud.com/809a56879f184aa39f31e345595ea2a8.png";
              break;
            case "习惯型":
              this.imgUrl =
                "https://meditation-1256110421.cos.ap-chengdu.myqcloud.com/a94624eba9294fbebc98390b2c561a4e.png";
              break;
            case "情感逃避型":
              this.imgUrl =
                "https://meditation-1256110421.cos.ap-chengdu.myqcloud.com/54efb10295db40e8b55b67c2ee2436c3.png";
              break;
            case "非讨好型人格":
              this.imgUrl =
                "https://meditation-1256110421.cos.ap-chengdu.myqcloud.com/6dd3400aad1e40a2af92143598f76b95.png";
              break;
          }
        } else if (res.data.result.name == "剁手倾向测试结果") {
          this.isThfg = false;
          //把背景换成矩形图
          this.isCircle = true;
          //认知特征总分和类别分数
          let rzScoreSum = res.data.result.mychart[0].score;
          let rzScore = res.data.result.mychart[0].subs_scores;
          //情感特征总分和分类别分数
          let qgScoreSum = res.data.result.mychart[1].score;
          let qgScore = res.data.result.mychart[1].subs_scores;
          this.drawLineRash(rzScoreSum, rzScore, qgScoreSum, qgScore);
        } else if (res.data.result.name == "职业自画像测评结果") {
          this.zyzhx = true;
          this.mychart.forEach((item, index) => {
            let that = this;
            setTimeout(function () {
              that.initMap(item, index);
            }, 500);
          });
        } else {
          this.drawLine(this.arr, this.indicator, this.mount);
        }

        if (res.data.is_commented.key === "yes") {
          this.isCommented = true;
        }

        // if(res.data.result.dimensionless[0].name == '经验开放'){
        // 	let that = this
        // 	setTimeout(function(){
        // 		that.drawLines()
        // 	 }, 500);
        // }

        const appraisal_id = store.state.appraisal_id;
        const Img = this.user.avatar;
        const Name = this.user.nick_name;
        // var ProjectName=encodeURI(Name)
        const ISVip = this.user.is_vip.key === "yes";
        const url = window.location.href.split("#")[0];
        if (this.$route.query.type === "share") {
        } else {
          this.$router.push(
            `/test/${this.eval_id}/result?type=share&appraisal_id=${
              this.appraisal_id
            }&img1=${encodeURIComponent(Img)}`
          );
        }
        const dataForWeixin = {
          title: res.data.evaluation.title, // 分享标题
          desc: "来看看我的测评结果...", // 分享内容
          // desc: `${url}#/test/${this.eval_id}/result?type=share&appraisal_id=${this.appraisal_id}&img1=${encodeURIComponent(Img)}`,
          linkurl: `${url}#/test/${this.eval_id}/result?type=share&Name=${
            res.data.tester.name
          }&appraisal_id=${this.appraisal_id}&img1=${encodeURIComponent(Img)}`, // 分享链接
          img: res.data.evaluation.detail_image, // 分享内容显示的图片(图片必须是正方形的链接)
        };
        // if(this.isWe)
        const ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          sdk.getJSSDK(dataForWeixin);
        }
        this.$nextTick(() => {
          const titleNodes = Array.from(
            this.$el.querySelectorAll(".title1, .content span")
          )
            .map((node) => node.textContent && node.textContent.trim())
            .filter(Boolean);
          console.log("[result-debug] rendered-titles", titleNodes);
        });
      })
      .catch((err) => {
        //console.log(err)
      });
  },
  mounted() {
    //监听页面滚动
    // this.$refs.initalDom.addEventListener('scroll',()=>{
    //   this.handleScroll();
    // })
  },
  watch: {
    rTests(val) {
      this.rTests = val;
    },
    appraisal_id(val) {
      this.appraisal_id = val;
      //console.log('也普遍化',this.appraisal_id,val)
    },
  },

  methods: {
    initMap(v, index) {
      var echarts = require("echarts");
      let myChart;
      myChart = echarts.init(document.getElementById("zyChart_" + index));
      myChart.setOption({
        yAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
            color: "#999",
          },
          data: v.names,
        },
        xAxis: {
          show: true,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        grid: {
          top: 0,
          right: "10%",
          left: "10%",
          bottom: "30%",
        },
        series: [
          {
            zlevel: 1,
            type: "bar",
            barWidth: "10px",
            barGap: "-100%",
            label: {
              show: false,
              position: "right",
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    // color: "rgba(0, 253, 255, 1)",
                    color: v.colors[0],
                  },
                  // {
                  //   offset: 1,
                  //   // color: "rgba(68, 215, 182, 1)",
                  //   color: "black",
                  // },
                ]),
                barBorderRadius: [0, 0, 20, 0],
              },
            },
            data: [{ name: v.names[0], value: v.left }],
          },
          {
            type: "bar",
            barWidth: "10px",
            showBackground: false,
            label: {
              show: false,
              position: "right",
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    // color: "rgba(255, 235, 0, 1)",
                    color: v.colors[1],
                  },
                  // {
                  //   offset: 1,
                  //   // color: "rgba(215, 170, 68, 1)",
                  //   color: "white",
                  // },
                ]),
                barBorderRadius: [0, 0, 0, 20],
              },
            },
            data: [{ name: v.names[1], value: v.left + v.right }],
          },
        ],
      });
    },
    //获取当前滑动的高度，并传值
    handleScroll(e) {
      if (!this.firstShow) {
        return;
      }
      // 如果用户滑了300的高度，那就让推荐显示
      console.log(document.querySelectorAll(".vd-content")[0].scrollTop);
      if (document.querySelectorAll(".vd-content")[0].scrollTop >= 800) {
        this.show = true;
        this.firstShow = false;
      }
    },

    changeTextToObject(object, islast) {
      var res = {
        tab: "",
        islast: false,
        content: [
          {
            subtitle: "",
            text: [],
          },
        ],
      };
      res.islast = islast;
      res.tab = object.name;
      res.content[0].text = this.getText(object.description);
      console.log(this.getText(object.description));
      return res;
      // object
    },
    getText(desc) {
      // //console.log(desc)
      // //console.log(desc.split('\n'))
      return desc.split("\\n");
    },
    // 从路由获取信息
    // 检测路由是否带有share
    getUrlInfo() {
      let address = "";
      if (
        window.location.href.indexOf("code") == -1 &&
        window.location.href.indexOf("continueFlag") == -1
      ) {
        address = window.location.href.split("?")[1].split("&");
      } else {
        address = window.location.href.split("?")[2].split("&");
      }

      let addressObj = {};
      for (var i = 0; i < address.length; i++) {
        let arr = address[i].split("=");
        if (!addressObj[arr[0]]) {
          addressObj[arr[0]] = arr[1];
        }
      }
      //console.log('路由信息',addressObj);//新路由信息
      return addressObj;
    },
    goMycomment(id) {
      // this.$router.push("/test/" + id + "/mycomment");
      this.$router.push("./mycomment");
    },
    handleExit() {
      this.showShare = false;
    },
    goHome() {
      this.$router.push("/index");
    },
    share() {
      // this.$refs.shareIcon.classList.add('animated', 'slideInRight')
      const appraisal_id = this.appraisal_id;
      const Img = this.img;
      const Name = this.name;
      var ProjectName = encodeURI(Name);
      const ISVip = this.isVip;
      const url = window.location.href.split("#")[0];
      const dataForWeixin = {
        title: "酷炫脑精神测评", // 分享标题
        desc: this.testName, // 分享内容
        linkurl: `${url}#/test/${this.eval_id}/result?appraisal_id=${appraisal_id}&img1=${Img}&Name=${Name}&ISVip=${ISVip}&type=share`, // 分享链接
        img: this.resultImg, // 分享内容显示的图片(图片必须是正方形的链接)
      };
      this.showShare = true;
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        sdk.getJSSDK(dataForWeixin);
      }
    },
    handleCloseShare() {
      this.showShare = false;
    },
    goClass() {
      this.$router.push("./../../../class");
    },
    changeQuote(str) {
      // Object.repl
      const regex = /\’/gm;
      const subst = `"`;
      let result = str.replace(regex, subst);
      // result.replace(/\n/g, '<br>')
      // val
      return result;
    },
    comment() {
      this.$router.push("./comment");
    },

    checkDim(object) {
      console.log(object[0]);

      // return typeof (object[0].description)!=='string'
    },
    //这里是echarts画图
    drawLines(xData, yData, index, max) {
      //下面是导入echarts的各个组件
      require("echarts/lib/component/grid");
      require("echarts/lib/chart/line");
      let echarts = require("echarts/lib/echarts");
      require("echarts/lib/component/tooltip");
      require("echarts/lib/component/title");
      require("echarts/lib/component/legend");
      let myChart;
      console.log(document.getElementById("myChart2"));
      myChart = echarts.init(document.getElementById("myChart2_" + index));

      let option = {
        // backgroundColor: 'rgba(116, 135, 195, 0.6)',
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        //这里是修改图表的大小
        grid: {
          top: "23px",
          bottom: "40px",
          right: "18px",
          left: "28px",
        },
        tooltip: {},
        xAxis: {
          type: "category",
          data: xData,
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.6)",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              fontSize: "12",
              fontWeight: 400,
              color: "#00165D",
            },
          },
        },
        yAxis: {
          max: max || null,
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#00165D",
            },
          },
        },
        series: [
          {
            data: yData,
            type: "line",
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "rgba(0, 22, 93, 1)",
                lineStyle: {
                  color: "rgba(255,225,255,1)",
                },
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
    // SM倾向
    drawPie(xData, yData, yMaxData) {
      //下面是导入echarts的各个组件
      require("echarts/lib/component/grid");
      require("echarts/lib/chart/line");
      let echarts = require("echarts/lib/echarts");
      require("echarts/lib/component/tooltip");
      require("echarts/lib/component/title");
      require("echarts/lib/component/legend");
      let myChart = echarts.init(document.getElementById("myChart3"));
      let total = 0;
      for (let i = 0; i < yData.length; i++) {
        total += yData[i] / yMaxData[i];
      }

      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b}({d}%)",
        },
        series: [
          {
            name: "SM",
            type: "pie", // 设置图表类型为饼图
            radius: "70%", // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
            data: (function () {
              var res = [];
              for (let i = 0; i < xData.length; i++) {
                res.push({
                  value: yData[i] / total,
                  name: xData[i],
                });
              }
              return res;
            })(),
          },
        ],
      });
    },
    //职业自画像
    drawLineZY(xData, yData, max) {
      require("echarts/lib/component/grid");
      require("echarts/lib/chart/line");
      let echarts = require("echarts/lib/echarts");
      require("echarts/lib/component/tooltip");
      require("echarts/lib/component/title");
      require("echarts/lib/component/legend");
      let myChart;
      console.log(document.getElementById("myChart"));
      myChart = echarts.init(document.getElementById("myChart"));

      let option = {
        // backgroundColor: 'rgba(116, 135, 195, 0.6)',
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        grid: {
          top: "35px",
          bottom: "30px",
          right: "18px",
          left: "31px",
        },
        tooltip: {},
        xAxis: {
          type: "category",
          data: xData,
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.6)",
            },
          },
          axisLabel: {
            show: true,
            lineStyle: {
              color: "rgb(66, 104, 110)",
            },
            textStyle: {
              fontSize: "8",
              fontWeight: 600,
              color: "rgb(66, 104, 110)",
            },
          },
        },
        yAxis: {
          max: max || null,
          type: "value",
          axisLine: {
            lineStyle: {
              color: "rgb(66, 104, 110)",
            },
            textStyle: {
              fontSize: "7",
              color: "rgb(66, 104, 110)",
            },
          },
        },
        series: [
          {
            data: yData,
            type: "line",
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "rgba(0, 22, 93, 1)",
                lineStyle: {
                  color: "rgb(66, 104, 110)",
                },
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
    // 冲动消费的图
    drawLineRash(rzScoreSum, rzScore, qgScoreSum, qgScore) {
      let echarts = require("echarts/lib/echarts");
      require("echarts/lib/component/tooltip");
      require("echarts/lib/component/title");
      require("echarts/lib/component/legend");
      let myChart;
      let options;
      //这里是雷达图的依赖
      require("echarts/lib/chart/radar");
      require("echarts/lib/component/radar");
      //这里是柱状图的依赖
      require("echarts/lib/component/grid");
      require("echarts/lib/chart/bar");
      //虚线依赖
      require("echarts/lib/component/markLine");
      myChart = echarts.init(document.getElementById("myChart"));
      // console.log(myChart)
      // debugger
      options = {
        //这是柱状图组件
        grid: {
          top: "35px",
          bottom: "30px",
          right: "20px",
          left: "0px",
          containLabel: true, // gird 区域是否包含坐标轴的刻度标签
        },
        xAxis: {
          show: true,
          type: "value",
          max: 130,
          boundaryGap: [0, 0.01],
          interval: 33,
          //X坐标轴轴线
          axisLine: {
            show: false, // 是否显示
            // symbol: ['none', 'arrow'],  // 是否显示轴线箭头
            // symbolSize: [8, 8], // 箭头大小
            // symbolOffset: [0, 7],  // 箭头位置
            // // ------   线 ---------
            // lineStyle: {
            //   color: 'blue',
            //   width: 1,
            //   type: 'solid'
            // }
          },
          //X坐标轴刻度
          axisTick: {
            show: false, // 是否显示
            inside: false, // 是否朝内
            length: 3, // 长度
            // lineStyle: {   // 默认取轴线的样式
            //   color: 'red',
            //   width: 1,
            //   type: 'solid'
            // }
          },
          //X坐标轴刻度标签
          axisLabel: {
            show: false, // 是否显示
            inside: false, // 是否朝内
            rotate: 0, // 旋转角度
            margin: 10, // 刻度标签与轴线之间的距离
            color: "rgb(66,104,110)", // 默认取轴线的颜色
          },
          //// gird区域中的分割线
          splitLine: {
            show: true, // 是否显示
            lineStyle: {
              color: "#778899",
              width: 1,
              type: "solid",
            },
          },
          // //这是次分割线，对齐次刻度线
          // minorSplitLine:{
          //   show:true,
          //    lineStyle: {
          //     color: '#778899',
          //     width: 1,
          //     type: 'dahsed'
          //   }
          // },
          // minorTick:{
          //   show:true,
          //   splitNumber:2,
          //   length:3,
          //   lineStyle: {
          //     color: '#778899',
          //     width: 1,
          //     type: 'dahsed'
          //   }
          // },
          // data: ['5', '10', '15', '20', '25']
        },
        yAxis: {
          type: "category",
          data: [
            {
              value: `认知特征${rzScoreSum}分`,
            },
            { value: `情感特征${qgScoreSum}分` },
          ],
          axisTick: {
            // 坐标轴的刻度
            show: true, // 是否显示
            inside: false, // 是否朝内
            length: 3, // 长度
            lineStyle: {
              color: "#778899", // 默认取轴线的颜色
              width: 1,
              type: "solid",
            },
          },
          axisLabel: {
            // 坐标轴的标签
            show: true, // 是否显示
            textStyle: {
              color: "#42686E",
              fontSize: "13",
              lineHeight: 20,
              fontWeight: "bold",
            },
            interval: 0,
            //设置代码每两个就自动换行
            formatter: function (params) {
              var newParamsName = ""; // 最终拼接成的字符串
              var paramsNameNumber = params.length; // 实际标签的个数
              var provideNumber = 4; // 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = ""; // 表示每一次截取的字符串
                  var start = p * provideNumber; // 开始截取的位置
                  var end = start + provideNumber; // 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr; // 最终拼成的字符串
                }
              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName;
            },
          },
        },
        //虚线
        // markLine:{
        // symbol:"none",
        // data:[{
        //   silent:false,
        //   lineStyle:{
        //     type:"solid",
        //     color:"#94BCB4"
        //   },
        //   xAxis:25
        // }]
        // } ,

        series: [
          {
            name: "1",
            type: "bar",
            data: [
              { value: rzScore[0], name: "不顾未来" },
              { value: qgScore[2], name: "购买冲动" },
            ],
            label: {
              // 图形上的文本标签
              show: true,
              formatter: "{b}",
              color: "#4A4A4A",
              position: "right", // 相对位置
              // distance:0,//距离图形元素的距离
              rotate: 0, // 旋转角度
              fontSize: 12,
            },
            itemStyle: {
              // 图形的形状
              color: "#42686E",
              // barBorderRadius: [18, 18, 0 ,0]
            },
            markLine: {
              symbol: "none",
              data: [
                {
                  silent: false,
                  lineStyle: {
                    type: "dashed",
                    color: "#94BCB4",
                  },
                  xAxis: 60,
                },
              ],
              label: {
                show: false,
              },
            },
          },
          {
            name: "2",
            type: "bar",
            data: [
              { value: rzScore[1], name: "快速决策" },
              { value: qgScore[1], name: "购买体验" },
            ],
            label: {
              show: true,
              color: "#4A4A4A",
              formatter: "{b}",
              fontSize: 12,
              position: "right", // 相对位置
              // distance:0,//距离图形元素的距离
              rotate: 0, // 旋转角度
            },
            itemStyle: {
              // 图形的形状
              color: "#7B989D",
              // barBorderRadius: [18, 18, 0 ,0]
            },
          },
          {
            name: "3",
            type: "bar",
            data: [
              { value: rzScore[2], name: "非计划性" },
              { value: qgScore[0], name: "调节心情" },
            ],
            formatter: "{b}",
            label: {
              show: true,
              color: "#4A4A4A",
              formatter: "{b}",
              fontSize: 12,
              position: "right", // 相对位置
              // distance:0,//距离图形元素的距离
              rotate: 0, // 旋转角度
            },
            itemStyle: {
              // 图形的形状
              color: "#CCE0E3",
              // barBorderRadius: [18, 18, 0 ,0]
              //  barWidth: 20,  // 柱形的宽度
              //  barCategoryGap: '20%',  // 柱形的间距
            },
          },
        ],
      };

      options && myChart.setOption(options);
    },
    drawLine: function (valueArr, indicatorArr, params) {
      //第一个参数是用户的得分，第二个参数是种类和种类总分，第三个参数是有多少种类
      console.log(valueArr, indicatorArr, params);
      let echarts = require("echarts/lib/echarts");
      require("echarts/lib/component/tooltip");
      require("echarts/lib/component/title");
      require("echarts/lib/component/legend");
      let myChart;
      let options;
      if (params === 1) {
        require("echarts/lib/chart/pie");
        require("echarts/lib/component/graphic");
        myChart = echarts.init(document.getElementById("myChart"));
        options = {
          animation: false,
          graphic: {
            //图形中间文字
            type: "text",
            left: "center",
            top: "center",
            style: {
              text: indicatorArr[0].text,
              textAlign: "center",
              fill: "#42686E",
              fontSize: 18,
            },
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: ["50%", "70%"],
              avoidLabelOverlap: false,
              color: ["#ECEFF5", "#42686E"],
              label: {
                show: false,
                position: "center",
              },
              data: [
                {
                  value: this.intervalLength - valueArr[0],
                },
                {
                  value: valueArr[0],
                },
              ],
            },
          ],
        };
      } else if (params === 2) {
        this.hideChart = true;
        this.name1 = indicatorArr[0].text;
        this.name2 = indicatorArr[1].text;
        this.number = (valueArr[0] / indicatorArr[0].max) * 100;
        this.numbers = (valueArr[1] / indicatorArr[1].max) * 100;
      } else {
        //这里是雷达图的依赖
        require("echarts/lib/chart/radar");
        require("echarts/lib/component/radar");
        //这里是柱状图的依赖
        // require('echarts/lib/component/grid');
        // require('echarts/lib/chart/bar');
        myChart = echarts.init(document.getElementById("myChart"));
        // console.log(myChart)
        // debugger
        options = {
          // 这是雷达图组件
          radar: [
            {
              indicator: indicatorArr,
              center: ["50%", "50%"],
              radius: ["0%", "55%"], // 修改大小
              startAngle: 90,
              splitNumber: 4,
              shape: "circle",
              name: {
                formatter: function (val) {
                  var strs = val.split(""); //字符串数组
                  var str = "";
                  for (var i = 0, s; (s = strs[i++]); ) {
                    //遍历字符串数组
                    str += s;
                    if (!(i % 3)) str += "\n"; //按需要求余
                  }
                  return str;
                },
                textStyle: {
                  color: "rgb(96, 141, 156)",
                  // align: 'left',
                },
              },
              splitArea: {
                areaStyle: {
                  color: [
                    "rgb(158,183,208)",
                    "rgb(146,175,194)",
                    "rgb(137,169,186)",
                    "rgb(115,153,170)",
                    "rgb(96, 141, 156)",
                  ],
                },
              },
              axisLine: {
                lineStyle: {
                  color: "rgba(255, 255, 255, 0.5)",
                },
              },
              splitLine: {
                lineStyle: {
                  color: "rgba(255, 255, 255, 0.5)",
                },
              },
            },
          ],
          series: [
            {
              name: "雷达图",
              type: "radar",
              itemStyle: {
                normal: {
                  color: "rgba(255,225,255,.3)",
                  lineStyle: {
                    color: "rgba(255,225,255,.3)",
                  },
                },
              },
              emphasis: {
                lineStyle: {
                  width: 2,
                  color: "white",
                },
              },
              data: [
                {
                  value: valueArr,
                  // name: '图二',
                  areaStyle: {
                    color: "#F2F2F2",
                  },
                },
              ],
            },
          ],
        };

        //这是柱状图组件
        //     grid: {
        //         top: "35px",
        //         bottom: "30px",
        //         right: "20px",
        //         left: "0px",
        //         containLabel: true // gird 区域是否包含坐标轴的刻度标签
        //     },
        //     xAxis: {
        //         show:true,
        //         type: 'value',
        //         boundaryGap: [0, 0.01],
        //         //X坐标轴轴线
        //         axisLine:{
        //             show: false,  // 是否显示
        //             // symbol: ['none', 'arrow'],  // 是否显示轴线箭头
        //             // symbolSize: [8, 8], // 箭头大小
        //             // symbolOffset: [0, 7],  // 箭头位置
        //             // // ------   线 ---------
        //             // lineStyle: {
        //             //   color: 'blue',
        //             //   width: 1,
        //             //   type: 'solid'
        //             // }
        //         },
        //         //X坐标轴刻度
        //         axisTick: {
        //           show:false,  // 是否显示
        //           inside: false,  // 是否朝内
        //           length: 3,     // 长度
        //           // lineStyle: {   // 默认取轴线的样式
        //           //   color: 'red',
        //           //   width: 1,
        //           //   type: 'solid'
        //           // }
        //         },
        //         //X坐标轴刻度标签
        //         axisLabel: {
        //           show: true,  // 是否显示
        //           inside: false, // 是否朝内
        //           rotate: 0, // 旋转角度
        //           margin: 10, // 刻度标签与轴线之间的距离
        //           color: 'rgb(66,104,110)'  // 默认取轴线的颜色
        //         },
        //         //// gird区域中的分割线
        //         splitLine: {
        //           show: true,  // 是否显示
        //           lineStyle: {
        //             color: '#778899',
        //             width: 1,
        //             type: 'solid'
        //           }
        //         },
        //         // //这是次分割线，对齐次刻度线
        //         // minorSplitLine:{
        //         //   show:true,
        //         //    lineStyle: {
        //         //     color: '#778899',
        //         //     width: 1,
        //         //     type: 'dahsed'
        //         //   }
        //         // },
        //         // minorTick:{
        //         //   show:true,
        //         //   splitNumber:2,
        //         //   length:3,
        //         //   lineStyle: {
        //         //     color: '#778899',
        //         //     width: 1,
        //         //     type: 'dahsed'
        //         //   }
        //         // },
        //         data: ['5', '10', '15', '20', '25']
        //     },
        //     yAxis: {
        //         type: 'category',
        //         data: [{
        //           value:'情感特征',
        //         },{value:'认知特征'}],
        //         axisTick: {      // 坐标轴的刻度
        //           show: true,    // 是否显示
        //           inside: false,  // 是否朝内
        //           length: 3,      // 长度
        //           lineStyle: {
        //             color: '#778899',  // 默认取轴线的颜色
        //             width: 1,
        //             type: 'solid'
        //           }
        //         },
        //         axisLabel: {      // 坐标轴的标签
        //             show: true,    // 是否显示
        //             interval:0,
        //             //设置代码每两个就自动换行
        //             formatter:function(params){
        //               var newParamsName = "";// 最终拼接成的字符串
        //               var paramsNameNumber = params.length;// 实际标签的个数
        //               var provideNumber = 2;// 每行能显示的字的个数
        //               var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
        //               // 条件等同于rowNumber>1
        //               if (paramsNameNumber > provideNumber) {
        //               for (var p = 0; p < rowNumber; p++) {
        //                   var tempStr = "";// 表示每一次截取的字符串
        //                   var start = p * provideNumber;// 开始截取的位置
        //                   var end = start + provideNumber;// 结束截取的位置
        //                   // 此处特殊处理最后一行的索引值
        //                   if (p == rowNumber - 1) {
        //                       // 最后一次不换行
        //                       tempStr = params.substring(start, paramsNameNumber);
        //                   } else {
        //                       // 每一次拼接字符串并换行
        //                       tempStr = params.substring(start, end) + "\n";
        //                   }
        //                   newParamsName += tempStr;// 最终拼成的字符串
        //               }

        //               } else {
        //               // 将旧标签的值赋给新标签
        //               newParamsName = params;
        //               }
        //               //将最终的字符串返回
        //               return newParamsName
        //                                       }
        //                                       }
        //         },

        //     series: [
        //         {
        //             name: '1',
        //             type: 'bar',
        //             data: [ {value:valueArr[0], name:'不顾未来'},
        //                      {value:valueArr[1], name:'购买冲动'}],
        //             label: {   // 图形上的文本标签
        //               show: true,
        //               formatter: '{b}',
        //               color:"#000",
        //               position: 'right', // 相对位置
        //               // distance:0,//距离图形元素的距离
        //               rotate: 0,  // 旋转角度
        //               fontSize:12,
        //             },
        //             itemStyle: {    // 图形的形状
        //               color: 'rgb(66,104,110)',
        //               // barBorderRadius: [18, 18, 0 ,0]
        //             },
        //         },
        //         {
        //             name: '2',
        //             type: 'bar',
        //             data: [ {value:valueArr[2], name:'快速决策'},
        //                      {value:valueArr[3], name:'购买体验'}],
        //             label:{
        //               show: true,
        //               color:"#000",
        //              formatter: '{b}',
        //             fontSize:12,
        //               position: 'right', // 相对位置
        //               // distance:0,//距离图形元素的距离
        //               rotate: 0,  // 旋转角度

        //             },
        //              itemStyle: {    // 图形的形状
        //               color: 'rgb(123,152,157)',
        //               // barBorderRadius: [18, 18, 0 ,0]
        //             },
        //         },
        //         {
        //             name: '3',
        //             type: 'bar',
        //             data: [ {value:valueArr[4], name:'非计划性'},
        //                      {value:valueArr[3], name:'调节心情'}],
        //             formatter: '{b}',
        //             label:{
        //               show: true,
        //               color:"#000",
        //              formatter: '{b}',
        //               fontSize:12,
        //               position: 'right', // 相对位置
        //               // distance:0,//距离图形元素的距离
        //               rotate: 0,  // 旋转角度

        //             },
        //             itemStyle: {    // 图形的形状
        //               color: 'rhb(204,224,227)',
        //               // barBorderRadius: [18, 18, 0 ,0]
        //             //  barWidth: 20,  // 柱形的宽度
        //             //  barCategoryGap: '20%',  // 柱形的间距
        //             },
        //         }
        //     ]
        //  }
      }
      options && myChart.setOption(options);
    },
    // goMycomment() {
    //   this.$router.push("./mycomment");
    // },
    toCode() {
      // this.firstFlag = false;
      // this.relatedFlag = false;
      this.$router.push("./save");
      // this.bindQRCode()
    },
  },
  components: {
    TestList,
    result_detail,
    result_article,
    result_window,
    appointGuilder,
    naviateToWxapp,
    watchMore,
  },
};
</script>

<style lang="less" scoped>
@import "~Style/index.less";
.box {
  // width: 283px;
  margin: 0 10px;
  display: flex;
  color: #000;
  justify-content: space-between;
  line-height: 20px;
  position: relative;
  top: -30px;
  .left {
    text-align: left;
  }
  .right {
    text-align: right;
  }
}
.close {
  position: fixed;
  bottom: 104px;
  right: 7px;
  height: 20px;
  width: 20px;
  z-index: 1000;
  /* background: rgb(172,147,92); */
  text-align: center;
  /* line-height: 20px; */
  color: rgb(172, 147, 92);
  font-size: 16px;
  font-weight: 600;
}
.result {
  position: relative;
  overflow: hidden;
  font-family: "SourceHanSansCN-Light";
}

.fixedHeight {
  height: 38rem;
}
.resFont {
  text-align: center;
  font-size: 14px;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #42686e;
}
.resFont1 {
  font-size: 12px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #42686e;
  margin-top: 5px;
}

.imgbg {
  // background-image: linear-gradient(to bottom,
  //         rgba(0, 0, 0, 0.01),
  //         rgba(0, 0, 0, 0.5));
  // background-image: -ms-linear-gradient(to bottom,
  //         rgba(0, 0, 0, 0.01),
  //         rgba(0, 0, 0, 0.5));
  // background-image: -moz-linear-gradient(linear,
  //         left top,
  //         left bottom,
  //         from(rgba(0, 0, 0, 0.01)),
  //         to(rgba(0, 0, 0, 0.5)));
  // background-image: -webkit-linear-gradient(to bottom,
  //         rgba(0, 0, 0, 0.01),
  //         rgba(0, 0, 0, 0.5));
  // background-image: -o-linear-gradient(to bottom,
  //         rgba(0, 0, 0, 0.2),
  //         rgba(0, 0, 0, 0.5));
  // width: 100%;
  height: calc(0.8 * 100vw);
  position: absolute;
  z-index: -1;
  // margin-top: 10px;
  // z-index: 1;
  // margin-left: 5%;
  // border-radius: 0.5rem;

  .head {
    width: 100vw;
    height: calc(200vw / 3);
    // border-radius: 0.5rem;
    // mix-blend-mode: overlay;
  }
}

// 头图
.img1 {
  background-image: url("./../../../assets/img/hengline.png");
  background-repeat: no-repeat;
  background-size: 8px 100%;
  position: absolute;
  display: block;
  height: 90%;
  width: 8px;
  top: 5%;
  left: calc(50% - 4px);
}

.img2 {
  background-image: url("./../../../assets/img/shuline.png");
  background-repeat: no-repeat;
  background-size: 100%;
  position: absolute;
  width: 90%;
  left: 5%;
  top: calc(50% - 4px);
  height: 8px;
}

.bg-circle {
  .title {
    position: relative;
    bottom: 10%;
    background-image: url("./../../../assets/img/underline.png");
    background-size: 180px 8px;
    padding-bottom: 5px;
    /*margin-bottom: 30px;*/
    font-family: SourceHanSansCN-Regular;
    background-position: center;
    background-position: bottom;
    background-repeat: no-repeat;
    color: #42686e;
    font-weight: 500;
    font-size: 20px;
  }
}

.borderTest {
  width: 330px;
  height: 110px;
  background: linear-gradient(180deg, #48dcff 0%, #3bb7ff 100%);
}

#test_result {
  min-height: 703px;
  background-size: 100%;
  background-image: url("./../../../assets/img/bg up.png");
  /*background-position: top;*/
  background-repeat: no-repeat;
  background-size: contain;
  background-position-y: 301px;
  padding-top: 23px;
  background-color: rgba(214, 230, 232, 0.2);
  padding-bottom: 30px;
  /*position: relative;*/
}
.assImg {
  position: relative;
  background-image: url("./../../../assets/img/helper.jpg");
  background-repeat: no-repeat;
  background-size: 100%;
  display: block;
  width: 100vw;
  height: 269vw;
}
.hd {
  padding-top: 20px;
  padding-bottom: 5px;
  height: fit-content;
  background-color: #d6e6e8;

  img {
    width: 1.8rem;
    // height: 65px;
    border: 1px solid #fff;
    border-radius: 50%;
  }
}

.content {
  position: relative;
  text-align: center;

  .bgImg {
    /*position: absolute;*/
    /*display: block;*/
    /*height: 4.5rem;*/
    width: 70%;
    /*margin-top: -4.55rem;*/
    /*margin-left: 15%;*/
  }

  .hdImg {
    border-radius: 25px;
  }

  img {
    /*width: 90%;*/
    /*height: calc(90vw * 0.896);*/
    height: 100%;
  }

  .hd {
    overflow-x: hidden;
  }

  .name {
    background: white;
    display: inline-block;
    padding: 0 17px;
  }
}

.ftbtn {
  width: 90%;
}

.allbtn {
  border-radius: 8px;
}

.rlbtn {
  border-radius: 18px;
  background-color: #42686e;
  color: white;
}

.savebtn {
  border-radius: 18px;
  background-color: #fff;
  color: #000;
  border: 1px solid #4a4a4a;
}

.ftbtnGroup {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ft {
  width: 90%;
  margin: 0 auto;
  text-align: center;

  .qrcode {
    display: inline-block;
    margin-left: -20px;
  }

  .vaSup {
    vertical-align: super;
  }

  .vaSub {
    vertical-align: sub;
  }
}

.savePic {
  width: 100%;
  height: 100%;
  margin-top: -100%;
}

.ftbtnGroup_assess_long {
  width: 100%;
  height: 45px;
  font-size: 18px;
  border: none;
}

.ftbtnGroup_assess {
  width: 100%;
  // width: 48%;
  height: 45px;
  font-size: 18px;
  border: none;
}

.ftbtnGroup_savebtn {
  width: 48%;
  height: 45px;
  font-size: 18px;
  border: none;
}

.ftbtnGroup_tohome {
  width: 90%;
  height: 45px;
  color: #42686e;
  border: 2px solid #42686e;
  border-radius: 18px;
  font-size: 18px;
  margin-top: 12px;
}

.ftbtnGroup_checkall {
  margin-left: 5%;
  width: 90%;
  height: 38px;
  border-color: #979797;
  font-size: 18px;
  color: #4a4a4a;
}

.rel_test {
  width: 90%;
  margin: 0 auto;
  border-top: 1px solid #eaeaea;
}

.rel_test_title {
  margin: 18px 0;
  font-weight: bold;
  height: 18px;
  line-height: 18px;
}

.rel_test_more {
  margin-right: 0;
  color: #9b9b9b;
  font-weight: normal;
}

.result_img {
  // width:68px;
  // height:47px;
  position: absolute;
  right: 0;
  top: 345px;
  overflow: hidden;

  img {
    width: 2.5rem;
    margin-right: -1.3rem;
    // height:100%;
  }

  span {
    position: relative;
    top: -0.5rem;
  }
}

.share_ft {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 20;

  .guide {
    margin-left: 21%;
  }

  .icon {
    width: 23px;
    height: 23px;
    vertical-align: top;

    border-radius: 4px;
    margin: 0 8px;
  }

  .icon_D {
    width: 46px;
    height: 18px;
    margin: 0;
    vertical-align: middle;
  }

  p {
    color: #fff;
    font-size: 18px;
    height: 24px;
    line-height: 24px;
    text-align: left;

    text-indent: 31%;
    margin-bottom: 21px;
  }

  .share_ft_content {
    position: absolute;
    left: 0;
    top: 144px;
    width: 100%;
  }

  .exit {
    width: 110px;
    height: 41px;
    line-height: 41px;
    font-size: 14px;
    border: 1px solid #fff;
    text-indent: 0;
    text-align: center;
    border-radius: 41px;
    margin: 0 auto;
  }
}

.dot {
  display: inline-block;
  margin: 0 12px;
  width: 4px;
  height: 4px;
  border-radius: 4px;
  background-color: #f7b270;
  transform: translateY(-4px);
}

.report_logo {
  margin-top: 3.2rem;
  height: 63px;
  width: 236px;
  background-image: url("./../../../assets/img/report_logo.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0 auto;
  /*background-size: 50% 50%;*/
}

.nameTime {
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #000000;
  margin: 12px 29px;
  font-size: 11px;

  span {
    float: right;
  }
}
.thfg {
  margin-left: auto;
  margin-right: auto;
  margin-top: 15px;
  height: 204px;
  width: 323px;
  border-radius: 0% !important;
  border-color: #42686e;
  border: 0px solid #42686e !important;
  background-color: rgba(0, 0, 0, 0) !important;
}
.bg-rectangle {
  margin-top: 15px;
  // height: 204px;
  height: 230px;
  width: 323px;
  border-radius: 5%;
  border-color: #42686e;
  border: 5px solid #42686e;
  background-color: rgb(250, 254, 255);
  margin-left: auto;
  margin-right: auto;
}
.bg-circle {
  margin-top: 15px;
  height: 296px;
  width: 296px;
  border-radius: 50%;
  /*border-color: #42686E;*/
  border: 5px solid #42686e;
  background-color: white;
  margin-left: auto;
  margin-right: auto;
}

//调整了一下宽度和高度的代码
#myChart {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  /*top: 40%;*/
  // width: 7.5rem;
  // height: 7rem;
  width: 7rem;
  height: 6.5rem;
  // width: 6.5rem;
  // height: 6.5rem;
  transform: translateY(-50%);
}

.result_border {
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: justify;
  min-height: 150px;
  background-image: url("./../../../assets/img/result_border.png");
  background-size: 90%;
  background-position: top;
  background-repeat: no-repeat;
  margin-bottom: 20px;
}

/*.result_border{*/
/*    !*border-image-slice:31% 8% 21% 17%;*!*/
/*    !*border-image-width:1.5em 1.5em 1.5em 1.5em;*!*/
/*    !*border-image-outset:0px 0px 0px 0px;*!*/
/*    !*border-image-repeat:round round;*!*/
/*    !*background-repeat: no-repeat;*!*/

/*    background-image: url("./../../../assets/img/result_border.png");*/
/*}*/
.left-mark1 {
  display: inline-block;
  background-image: url("./../../../assets/img/Clip.png");
  /*background-image: url("/../../../assets/img/quotedblleft.png");*/
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 255px;
  width: 256px;
  height: 256px;
  position: absolute;
  top: -25px;
  left: 30px;
  /*z-index: 98;*/
}

.rect1 {
  background-image: url("./../../../assets/img/paper.png");
  background-size: contain;
  // background: rgba(255, 255, 255, 0.8);
  margin-top: 20px;
  /*padding-top: 20px;*/
  padding-bottom: 20px;
  // border: 3px solid orange;
  border-radius: 10px;
  /*background: hotpink;*/
  /*width: 100%;*/
  margin-left: 15px;
  margin-right: 15px;
  height: 100%;
  /*height: 150px;*/
  position: relative;
  margin-bottom: 10px;
  border: 2px solid #ccc;
  box-shadow: 0px 1px 8px 1px rgba(0, 0, 0, 0.13);
}

.result_desc1 {
  font-family: SourceHanSansCN-Regular;
  text-align: justify;
  display: inline-block;
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 20px;
  font-weight: 500;
  color: #4a4a4a;
  font-size: 16px;
  line-height: 28px;
  text-indent: 2em;
  /*z-index: 99;*/
  /*position: absolute;*/
  /*top: -2rem;*/
  /*top: 0;*/
  /*position: absolute;*/
}

.left-mark {
  background-image: url("./../../../assets/img/icon1.png");
  /*background-image: url("/../../../assets/img/quotedblleft.png");*/
  background-repeat: no-repeat;
  background-size: contain;
  width: 82px;
  height: 100px;
  float: left;
  margin: 40px 7px;
  /*z-index: 98;*/
}

.rect {
  background: #42686e;
  border-radius: 9px;
  border: 3px solid #8b572a;
  // background: rgba(255, 255, 255, 0.8);
  margin-top: 20px;
  /*padding-top: 20px;*/
  padding-bottom: 20px;
  // border: 3px solid orange;
  border-radius: 10px;
  /*background: hotpink;*/
  /*width: 100%;*/
  margin-left: 15px;
  margin-right: 15px;
  // height: 156px;
  height: 100%;
  /*height: 150px;*/
  position: relative;
  margin-bottom: 10px;
  font-size: 15px;
  display: block !important;
}

.title1 {
  font-size: 20px;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #ffffff;
  line-height: 22px;
  letter-spacing: 1px;
  margin-top: 16px;
  text-align: left;
}

.result_desc {
  font-family: SourceHanSansCN-Regular;
  text-align: justify;
  // display: inline-block;
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 13px;
  // text-indent: 2em;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: 1px;
  /*z-index: 99;*/
  /*position: absolute;*/
  /*top: -2rem;*/
  /*top: 0;*/
  /*position: absolute;*/
}

/*  .bottom_img{*/
/*    display: inline-block;*/
/*    min-height: 535px;*/
/*    min-width: 375px;*/
/*    background-size: 100%;*/
/*    background-image: url("./../../../assets/img/bg down.png");*/
/*    !*background-position: top;*!*/
/*    background-repeat: no-repeat;*/
/*    position: relative;*/
/*    bottom: 520px;*/
/*    z-index: 1;*/
/*  }*/
.userInfo {
  position: relative;
  top: 36px;
  /*width: 6.5rem;*/
  /*height: 6.5rem;*/
  transform: translateY(-50%);
}

.orangeBox {
  padding-top: 12px;
  padding-bottom: 12px;
  margin: 0.4rem;
  margin-top: 34px;
  margin-bottom: 34px;
  /*height: 300px;*/
  border: 5px solid orange;
  border-radius: 30px;
  /*margin-left: 0.4rem;*/
  /*margin-right: 0.4rem;*/
  // background-color: white;
  background-image: url("./../../../assets/img/underlineOrange.png");
  color: orange;
  padding-left: 20px;
  padding-right: 20px;

  .content {
    text-indent: 2em;
    font-size: 15px;
    letter-spacing: 1px;
    line-height: 26px;
    text-align: left;
  }
}

.title {
  // background-image: url("./../../../assets/img/underlineOrange.png");
  // background-size: 186px 8px;
  padding-bottom: 5px;
  margin-bottom: 10px;
  font-family: SourceHanSansCN-Regular;
  // background-position: center;
  // background-position: bottom;
  // background-repeat: no-repeat;
  // color: orange;
  font-size: 20px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #4a4a4a;
  line-height: 22px;
  letter-spacing: 1px;
  font-size: 20px;
}

</style>
